module.exports = function() {
  return new Worker(__webpack_public_path__ + "297b6981dc0325afedd4.worker.js");
};